import React from 'react';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import { useTranslation } from 'gatsby-plugin-react-i18next';
import styled from 'styled-components';
import Colors from '@components/shared/Colors';
import { TEXT_STYLES, TextVariant } from '@components/shared/design/Typography';
import NewsletterFormAlt from '@components/shared/NewsletterFormAlt';
import TwoColumn from '@components/shared/TwoColumn';
import { VMS_FOUNDERS_RESULTS_NEW_IMG } from '@constants';

interface Props {
  klaviyoListId: string;
}

const FoundersResultsReportSubscribe: React.FC<Props> = ({ klaviyoListId }) => {
  const { t } = useTranslation();

  return (
    <Container>
      <Inner>
        <TwoColumn gap="60px" mobileReverse={false} breakpoint="1024px" alignment="center">
          <TextWrap>
            <Title>{t('components.sti-founders-results.title')}</Title>
            <Description>{t('components.sti-founders-results.description')}</Description>
            <NewsletterFormAlt listId={klaviyoListId} />
            <HintText>{t('components.sti-founders-results.note')}</HintText>
          </TextWrap>
          <StyledImg src={VMS_FOUNDERS_RESULTS_NEW_IMG} alt="STI Founders Results" width="720" height="600" fetchpriority="low" />
        </TwoColumn>
      </Inner>
    </Container>
  );
};

export default FoundersResultsReportSubscribe;

const Container = styled.div`
  background: ${Colors.paleGold50};

  @media (max-width: 1024px) {
    padding: 56px 16px 0;
  }
`;

const Inner = styled.div`
  max-width: 1440px;
  width: 90vw;
  margin: 0 auto;
`;

const TextWrap = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 0;
  gap: 20px;
  max-width: 420px;
  color: ${Colors.navyBlue};

  @media (max-width: 1024px) {
    align-items: center;
  }
`;

const Title = styled.h3`
  ${TEXT_STYLES[TextVariant.Heading5]};
`;

const Description = styled.p`
  ${TEXT_STYLES[TextVariant.BodyRegularLG]};
  color: ${Colors.navyBlue};
`;

const HintText = styled.p`
  ${TEXT_STYLES[TextVariant.BodyRegularSM]};
  color: ${Colors.navyBlue};
  opacity: 0.6;
`;

const StyledImg = styled(LazyLoadImage)`
  height: 100%;
  max-width: 50%;
  min-height: 500px;
  width: auto;
  object-fit: cover;
  overflow: visible;

  @media (max-width: 1024px) {
    width: 100%;
    max-width: none;
    min-height: 320px;
    max-height: 460px;
  }
`;
